// Chakra imports

import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import FormDeptoOrcamento from "./components/Form";
import DeptoOrcamentoTable from "./components/Table";
import useDeptoOrcamento from "./hooks/useDeptoOrcamento";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const DeptoOrcamentoScreen = () => {
	const textColor = useColorModeValue("navy.700", "white");
	const brandStars = useColorModeValue("brand.500", "brand.400");
	const borderColor = useColorModeValue("secondaryGray.100", "whiteAlpha.100");

	const {
		accountSelected,
		add,
		cancelRef,
		changeInput,
		closeDelete,
		closeError,
		deletar,
		edit,
		error,
		errorMsg,
		errorTitle,
		list,
		loading,
		save,
		show,
		showDelete,
		showDeleteModal,
		showModal,

		deptoList,
		changeUser,
		selectedUser,
		users,
		condicaoPagamentos,
		showItemModal,
		showItem,
		enableDrag,
		isDragable,
		nomeRef,
		removeItem,
		reorder,
		saveCategory,
		changeItem,
		itens

	} = useDeptoOrcamento();
	return (
		<Box pt={{ base: '130px', md: '80px', xl: '80px' }}>


			<ConditionalRenderer
				conditions={[{
					condition: show,
					component: (
						<SimpleConditionalFrame
							backClick={() => showModal(false)}
							title="Cadastro de Planejamento Financeiro"
						>
							<FormDeptoOrcamento
								accountSelected={accountSelected}
								brandStars={brandStars}
								changeInput={changeInput}
								deptoList={deptoList}
								loading={loading}
								save={save}
								show={show}
								showModal={showModal}
								textColor={textColor}
								borderColor={borderColor}
								changeUser={changeUser}
								selectedUser={selectedUser}
								users={users}
								changeItem={changeItem}
								condicaoPagamento={condicaoPagamentos}
								drag={enableDrag}
								isDragable={isDragable}
								removeItem={removeItem}
								reorder={reorder}
								itens={itens}
								addRow={null}
								cancelRef={cancelRef}
								closeError={closeError}
								deleteRow={null}
								errorMsg={errorMsg}
								errorTitle={errorTitle}
								nomeRef={nomeRef}
								saveItem={saveCategory}
								showCategory={showItem}
								showItemModal={showItemModal}
							/>
						</SimpleConditionalFrame>
					)
				}]}
				fallback={(
					<SimpleGrid mb='20px' spacing={{ base: '20px', xl: '20px' }}>
						<DeptoOrcamentoTable
							add={add}
							cancelRef={cancelRef}
							closeDelete={closeDelete}
							deletar={showDeleteModal}
							edit={edit}
							list={list}
							remove={deletar}
							showDelete={showDelete}
						/>
					</SimpleGrid>
				)}
			/>

			<AlertDialog
				isOpen={error}
				leastDestructiveRef={cancelRef}
				onClose={closeError}
				isCentered
				motionPreset="slideInBottom"
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{errorTitle}
						</AlertDialogHeader>

						<AlertDialogBody>{errorMsg}</AlertDialogBody>

						<AlertDialogFooter>
							<Button
								ref={cancelRef}
								onClick={closeError}
								colorScheme={"blue"}
							>
								OK
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</Box>
	);
}
export default DeptoOrcamentoScreen;